import { lazy } from 'react';

const CustomElementTelegestio = lazy(() => import('./CustomElementTelegestio'));

export default CustomElementTelegestio;
